export default {
  name: [{ required: true, message: '请输入姓名', trigger: 'blur' },
  { max: 64, message: "超出最大长度 (64)", trigger: "blur" },],
  phone: [
    { max: 32, message: '超出最大长度 (32)', trigger: 'blur' },
  ],
  email: [
    { max: 256, message: '超出最大长度 (256)', trigger: 'blur' },
  ],
  sex: [{ required: true, message: '请选择性别', trigger: 'change' }],
}
